import React from 'react';
import ServiceCard from '../ui/ServiceCard';
import { homeServiceCards } from '../../data/services';
export default function ServicesSection() {
  return <section className="py-16 bg-white" data-id="element-220" data-mp="3anouuxb4duou">
      <div className="container mx-auto px-4" data-id="element-221" data-mp="35uc5um2j3lvk">
        <h2 className="text-3xl font-serif font-bold text-primary text-center mb-4" data-id="element-222" data-mp="35t17j1rur6bu">
          Our Medico-Legal Services
        </h2>
        <p className="text-slate-dark text-lg text-center max-w-3xl mx-auto mb-12" data-id="element-223" data-mp="2vwfzs8og7h4b">
          Independent psychiatric reports for solicitors, barristers, case
          managers and other instructing professionals. Each instruction is
          considered individually against Dr Syed’s expertise and availability.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-224" data-mp="2hxpyshyicxao">
          {homeServiceCards.map(service => {
          const Icon = service.icon;
          return <ServiceCard key={service.id} title={service.title} description={service.cardSummary} icon={<Icon className="h-10 w-10" aria-hidden="true" data-id="element-226" data-mp="2rw6qzzb9ds5g" />} link={service.link} data-id="element-225" data-mp="g5a982pt9j75" />;
        })}
        </div>
      </div>
    </section>;
}